import React from 'react'
import Hero from './Hero/Hero'
import WorkWithUs from './WorkWithUs/WorkWithUs'
import GettingStarted from './GettingStarted/GettingStarted'
import OurVehicles from './OurVehicles/OurVehicles'
import PlayBig from './PlayBig/PlayBig'
import FrequentlyAskedQuestions from './FrequentlyAskedQuestions/FrequentlyAskedQuestions'
import Page from '../../components/Page/Page'


const BecomeAPartner = () => {
    return (
        <Page title='CML | Become a Partner'>
            <Hero />
            <WorkWithUs />
            <GettingStarted />
            <OurVehicles />
            <PlayBig />
            <FrequentlyAskedQuestions />
        </Page>
    )
}

export default BecomeAPartner